import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: '<app-sidenav></app-sidenav>',
    standalone: false
})
export class AppComponent {
  title = 'Pace Fills';
}
